/* eslint-disable */

import axios from 'axios';
import axiosConfig from '../axiosConfig';
import {
	ChatRequest,
	ChatResponse,
	GenericResponse,
	InovationChatRequest,
	InovationChatResponse,
} from '../types';

export class ChatActions {
	public static SendMessage(request: ChatRequest): Promise<GenericResponse<ChatResponse>> {
		const url = 'app/ai/chat';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<ChatResponse>;
		});
	}

	/**
	 * Sends a message to the Innovation AI endpoint (used by Advanced AI page).
	 * Base URL is constructed from env vars:
	 *  - REACT_APP_INNOVATION_AI_API_ID
	 *  - REACT_APP_INNOVATION_AI_ENVIRONMENT
	 * Falls back to the hardcoded URL if env vars are missing.
	 */
	public static sendInovationAIMessage(
		request: InovationChatRequest
	): Promise<InovationChatResponse> {
		const apiId = process.env.REACT_APP_INNOVATION_AI_API_ID;
		const environment = process.env.REACT_APP_INNOVATION_AI_ENVIRONMENT;
		const fallback = 'https://ygqpos4pjd.execute-api.us-east-1.amazonaws.com/dev/chat';
		const API_KEY = 'c2051712053c930e9345e66e24a58de140f33e8be8ba6c01b242358774ef4f81';

		const url =
			apiId && environment
				? `https://${apiId}.execute-api.us-east-1.amazonaws.com/${environment}/chat`
				: fallback;

		const externalAxios = axios.create({
			withCredentials: false,
			timeout: 100000,
		});

		return externalAxios
			.post(url, request, {
				headers: {
					'Content-Type': 'application/json',
					'x-api-key': API_KEY,
				},
			})
			.then((res) => {
				const data = res.data;
				// If API Gateway responds with 202 Accepted, normalize response so callers can show the message
				if (res.status === 202) {
					const message =
						(data && (data.message || data.detail || data.response)) ??
						(typeof data === 'string' ? data : '');
					return {
						session_id: data?.session_id ?? '',
						response: message,
						status: 'pending',
						trace: data?.trace ?? [],
					} as InovationChatResponse;
				}

				// Normal 2xx behavior: if body is a string, wrap it; otherwise assume it matches InovationChatResponse
				if (typeof data === 'string') {
					return {
						session_id: '',
						response: data,
						status: 'complete',
						trace: [],
					} as InovationChatResponse;
				}

				return data as InovationChatResponse;
			});
	}
}
